// export const apiUrl = 'http://localhost:4000';
export const apiUrl = 'https://smartparking-api.herokuapp.com';


// WEBPACK FOOTER //
// ./src/baseparking-api/apiUrl.js